import { render, staticRenderFns } from "./NotificationModal.vue?vue&type=template&id=086b0dc5&scoped=true&"
import script from "./NotificationModal.vue?vue&type=script&lang=js&"
export * from "./NotificationModal.vue?vue&type=script&lang=js&"
import style0 from "./NotificationModal.vue?vue&type=style&index=0&id=086b0dc5&prod&lang=scss&scoped=true&"
import style1 from "./NotificationModal.vue?vue&type=style&index=1&id=086b0dc5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086b0dc5",
  null
  
)

export default component.exports